import { useI18n } from '../i18n/I18nContext.js';
import { Modal } from './Modal.js';

export interface ConfirmDialogProps {
  title: string;
  /** States the consequence in words. No bare "are you sure?". */
  consequence: string;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm(): void;
  onCancel(): void;
}

export function ConfirmDialog({
  title,
  consequence,
  confirmLabel,
  danger,
  busy,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useI18n();
  return (
    <Modal title={title} onClose={onCancel} busy={busy}>
      <p>{consequence}</p>
      <div className="modal__actions">
        <button type="button" className="btn btn--secondary" onClick={onCancel} disabled={busy}>
          {t('common.cancel')}
        </button>
        <button
          type="button"
          className={`btn ${danger ? 'btn--danger' : 'btn--primary'}`}
          onClick={onConfirm}
          disabled={busy}
        >
          {confirmLabel ?? t('common.confirm')}
        </button>
      </div>
    </Modal>
  );
}
